import * as React from 'react';

interface GovCo2025Props extends React.SVGProps<SVGSVGElement> {
  variant: 'blue' | 'white';
}

const GovCo2025 = ({ variant = 'white', ...props }: GovCo2025Props) => {
  const mainColor = variant === 'white' ? '#FFFFFF' : '#214C9A';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218.21 55.74" fill="none" {...props}>
      <g clipPath="url(#a)">
        <path
          fill="#D83744"
          d="M32.27 13.38a3 3 0 0 1-2-.75 2.937 2.937 0 0 1-.21-4.16L36.87 1a2.958 2.958 0 1 1 4.36 4l-6.77 7.5a2.94 2.94 0 0 1-2.19 1"
        />
        <path
          fill={mainColor}
          d="M65.44 9.57c-7.25 0-12.16 5.08-12.16 12.5S58.19 34.4 65.44 34.4s12.16-5 12.16-12.33-4.91-12.5-12.16-12.5Zm0 30.74c-11.58 0-19.33-7.5-19.33-18.33 0-10.83 7.75-18.32 19.33-18.32 11.58 0 19.33 7.49 19.33 18.41S77 40.31 65.44 40.31ZM117.83 6.32a3.005 3.005 0 0 1 2.84-1.74c2.25 0 4.5 1.91 3.16 4.49l-13.58 28a4.113 4.113 0 0 1-3.745 2.417 4.113 4.113 0 0 1-3.745-2.416L89.1 9.16c-1.42-2.59 1-4.67 3.33-4.67a3.16 3.16 0 0 1 2.92 1.83l9.49 20.83a32.232 32.232 0 0 1 1.75 4.75 33.067 33.067 0 0 1 1.83-4.75l9.42-20.83h-.01ZM123.84 35.64a3.997 3.997 0 0 1 4-4 3.999 3.999 0 0 1 4 4 3.775 3.775 0 0 1-3.91 4 3.822 3.822 0 0 1-4.08-4M159.15 3.66c5.58 0 10.75 2 13.41 4.16a3.34 3.34 0 0 1 1.08 2.33 2.995 2.995 0 0 1-1.596 2.524 3 3 0 0 1-2.984-.104 14.16 14.16 0 0 0-9.41-3c-6.42 0-11.75 4.66-11.75 12.58s5.33 12.24 11.75 12.24a13.91 13.91 0 0 0 9.41-2.91 3 3 0 0 1 4.58 2.41 3.006 3.006 0 0 1-1.08 2.25c-3.74 3.5-9.08 4.17-13.41 4.17-10.74 0-18.41-7-18.41-18.16s7.67-18.5 18.41-18.5M198.89 34.4c-7.25 0-12.16-5-12.16-12.33s4.91-12.5 12.16-12.5c6.81 0 11.56 4.49 12.11 11.2 0 .42.05.86.05 1.3 0 7.33-4.92 12.33-12.16 12.33Zm19.28-13.63c-.59-10.2-8.17-17.11-19.28-17.11-11.11 0-19.33 7.49-19.33 18.34s7.74 18.33 19.33 18.33c11.59 0 19.32-7.41 19.32-18.24v-1.3M34.92 21.15a3.66 3.66 0 0 1 3.65 3.64v11.6c0 16.79-18.27 22.78-32.18 17.48A7.002 7.002 0 0 1 4 52.51a2.73 2.73 0 0 1 1-4.79c1.8-.41 3.94.71 5.68 1 9.94 1.63 20.94-.94 20.94-12.32v-3c-2.75 4.42-7.42 6.75-13.5 6.75C7.5 40.14 0 33.14 0 22.4S6.71 4.86 16.69 3.8c.26 0 .67-.06 1.17-.08a3 3 0 0 1 2.31 5 2.91 2.91 0 0 1-1.87 1c-1.228.113-2.44.35-3.62.71-.742.261-1.455.597-2.13 1a11.82 11.82 0 0 0-5.39 10.4C7.16 29.31 12.49 34 19.32 34c5.51 0 10-3.12 11.61-8 .153-.533.263-1.078.33-1.63a3.65 3.65 0 0 1 3.62-3.16l.04-.06Z"
        />
        <path
          fill="#37B3D7"
          d="M26.88 19.36a2.94 2.94 0 0 1-2.18-4.92L30.55 8a2.958 2.958 0 1 1 4.36 4l-5.84 6.47a3 3 0 0 1-2.19 1"
        />
        <path
          fill="#F7A72E"
          d="M18.86 28.23h-.08a2.919 2.919 0 0 1-2.2-1.08l-4.14-5A2.958 2.958 0 1 1 17 18.38l2 2.4 5.28-5.84a2.942 2.942 0 1 1 4.37 3.94L21 27.26a2.921 2.921 0 0 1-2.18 1"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h218.21v55.74H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GovCo2025;
